import type {
  AddSubjectCommentRequest,
  SubjectReviewModel,
} from "@/features/cle-compliance/models/documentReview";
import type {
  DocumentCommentModel,
  DocumentCommentSender,
} from "@/features/cle-compliance/models/documentComment";
import { get, post } from "./util";

export const SUBJECT_REVIEW_QUERY_KEY = ["subject-review"] as const;

export const createSubjectReviewQueryKey = (subjectId: string) =>
  [...SUBJECT_REVIEW_QUERY_KEY, subjectId] as const;

const REVIEW_QUERY = "documents/review";

type DocumentCommentApiResponse = {
  id: string;
  documentId?: string;
  document_id?: string;
  subjectId?: string;
  subject_id?: string;
  actorId?: string;
  actor_id?: string;
  actorDisplayName?: string;
  actor_display_name?: string;
  from?: DocumentCommentSender;
  content: string;
  createdAt?: string;
  created_at?: string;
};

type SubjectReviewApiResponse = {
  subjectId?: string;
  subject_id?: string;
  comments?: DocumentCommentApiResponse[];
};

const mapDocumentComment = (
  comment: DocumentCommentApiResponse,
): DocumentCommentModel => ({
  id: comment.id,
  documentId:
    comment.documentId ??
    comment.document_id ??
    comment.subjectId ??
    comment.subject_id ??
    "",
  actorId: comment.actorId ?? comment.actor_id ?? "",
  actorDisplayName:
    comment.actorDisplayName ?? comment.actor_display_name ?? "",
  from: comment.from ?? "user",
  content: comment.content,
  createdAt: comment.createdAt ?? comment.created_at ?? "",
});

const mapSubjectReview = (
  subjectId: string,
  review: SubjectReviewApiResponse,
): SubjectReviewModel => ({
  subjectId: review.subjectId ?? review.subject_id ?? subjectId,
  comments: (review.comments ?? []).map(mapDocumentComment),
});

export const fetchSubjectReview = (
  subjectId: string,
): Promise<SubjectReviewModel> =>
  get<SubjectReviewApiResponse>({
    query: `${REVIEW_QUERY}/${subjectId}`,
  }).then((review) => mapSubjectReview(subjectId, review));

export const addSubjectComment = (
  subjectId: string,
  request: AddSubjectCommentRequest,
): Promise<DocumentCommentModel> =>
  post<DocumentCommentApiResponse>({
    query: `${REVIEW_QUERY}/${subjectId}/comments`,
    body: request,
  }).then(mapDocumentComment);
